const HTTP_STATUS = {
  CREATED: 201,
  FORBIDDEN: 403,
  OK: 200,
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400
}

export  { HTTP_STATUS }